import React from "react";
import { twMerge } from "tailwind-merge";

export default function FormFieldWrapper({
  children,
  className,
  noWrap = false,
}) {
  if (noWrap) {
    return children;
  }
  return (
    <div className={twMerge("flex flex-col gap-1", className)}>{children}</div>
  );
}
